module.exports = __webpack_public_path__ + "img/digi-crush-2.84a65844.png";